import { List } from "./services/List";
import dayjs from "dayjs";
import { useAtom, useAtomValue } from "jotai";
import { reklamodawcyAtom, userAtom, userJwtAtom, usersAtom } from "./services/atoms";
import { useMutation } from "./services/hooks";

var utc = require("dayjs/plugin/utc");
var timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Europe/Warsaw");

console.log("[dayjs]", dayjs().format("YYYY-MM-DDTHH:mm:ssZ"));

const ArticleQuery = {
  records: [`articles?offset=$from&title=ilike.*$search*&limit=10&order=id.desc&created_by=in.($created_by)&reklamodawca=in.($reklamodawca)`, true],
  aggregation: [`articles?select=count()&title=ilike.*$search*`, false],
}

export const CreateArticle = ['articles', 'POST']
export const DeleteArticle = ['articles?id=eq.$id', 'DELETE']


export const startingData = (created_by, changes = {}) => {
  return {
    title: "",
    excerpt: "",
    slug: "",
    fb_image: "",
    license: "copy",
    published_at: dayjs().toISOString(),
    first_publish: dayjs().toISOString(),
    auto_ads: 1,
    status: "draft",
    content: "jeśli widzisz tę wiadomość, zgłoś to na admin@histmag.org",
    created_by,
    htmlcontent: JSON.stringify([
      {
        id: "ze7mzgeGPI",
        type: "paragraph",
        data: { text: "Let's write an awesome story" },
      },
    ]),
    ...changes,
  };
};

export default () => {
  const jwt = useAtomValue(userJwtAtom)
  const [reklamodawcy] = useAtom(reklamodawcyAtom);
  const [users] = useAtom(usersAtom);

  const [res1, createMutation] = useMutation(CreateArticle);
  const [res2, deleteMutation] = useMutation(DeleteArticle);

  const [user] = useAtom(userAtom);

  console.log("[user]", user);

  return (
    <>
      <List
        mainKey={"title"}
        query={ArticleQuery}
        path="/articles"
        name="Artykuły"
        plural="artykułów"
        createAction={() => {
          createMutation({data: startingData(jwt.id)}).then((data) => {
            console.log(data);
            window.location.href = `/articles/${data[0].id}`;
          });
        }}
        filters={[
          {
            field: "reklamodawca",
            values: reklamodawcy.map((e) => ({
              value: e.reklamodawca,
              label: e.reklamodawca,
            })),
            parse: (e) => e,
          },
          {
            field: "created_by",
            values: [
              ...users.map((e) => ({ value: e.id, label: e.name })),
              {
                value: 0,
                label: "Nikt",
              },
            ],
            parse: (e) => parseInt(e),
          },
        ]}
        columns={(data) => (
          <>
            <div className="w-1/2 lg:w-2/12 px-4 mb-6 lg:mb-0">
              <a
                className="py-1 px-2 text-xs text-purple-500 bg-purple-50 rounded-full"
                href="#"
              >
                {data.status}
              </a>
            </div>
            <div className="w-1/2 lg:w-2/12 px-4 mb-6 lg:mb-0 text-xs">
              {/* {data.authors.map((author) => author.user.fname).join(", ")} */}
            </div>
            <div className="w-1/2 lg:w-2/12 px-4 mb-6 lg:mb-0">
              {data.title ? (
                <a
                  target="_blank"
                  className="py-1 px-2 text-xs text-purple-500 bg-purple-50 rounded-full"
                  href={`https://histmag.org/${data.slug}-${data.id}`}
                >
                  tekst
                </a>
              ) : (
                <span
                  onClick={async () => {
                    await deleteMutation({
                      id: data.id,
                    });
                    window.location.reload()
                  }}
                >
                  Usuń z CMS
                </span>
              )}
            </div>
          </>
        )}
      />
    </>
  );
};
